// import axiosInstance from "./axiosConfig";

// export const membershipAPI = {
//   // Create membership plan
//   createPlan: (data) => axiosInstance.post("/api/plans/create/", data),

//   // Get all plans
//   getPlans: () => axiosInstance.get("/api/plans/"),

//   // Get plan by ID
//   getPlanById: (id) => axiosInstance.get(`/api/plans/${id}/`),

//   // Update plan
//   updatePlan: (id, data) => axiosInstance.put(`/api/plans/${id}/update/`, data),

//   // Delete plan
//   deletePlan: (id) => axiosInstance.delete(`/api/plans/${id}/delete/`),
// };

import axiosInstance from "./axiosConfig";

export const membershipAPI = {
  // Create membership plan
  createPlan: (data) => axiosInstance.post("/api/plans/create/", data),

  // Get all plans
  getPlans: () => axiosInstance.get("/api/plans/"),

  // Get plan by ID
  getPlanById: (id) => axiosInstance.get(`/api/plans/${id}/`),

  // Update plan
  updatePlan: (id, data) => axiosInstance.put(`/api/plans/${id}/update/`, data),

  // Delete plan
  deletePlan: (id) => axiosInstance.delete(`/api/plans/${id}/delete/`),

  // Payments
  createPayment: (data) => axiosInstance.post("/api/payments/create/", data),
  getPlanPayments: (planId) =>
    axiosInstance.get(`/api/payments/plan/${planId}/`),
};
